import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { language } from './Language';

import DraggableDivImage from "../../DraggableDiv/DraggableDivImage"

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	handle_compressed_image_upload,

} from '../../../Utils';
import Hosts from '../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	const [/*dragId*/, setDragId] = useState();

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const handleDrag = (ev) => {
		console.log('drag ev', ev)

	  	setDragId(ev.currentTarget.id);
	};

	const handleDrop = (ev) => {

		console.log('drop')
		return

		/*const { dataset } = ev.target;
		const { order } = dataset

		console.log('drop')

		let divs = dados.current.content[order].media.image

		console.log('ev', ev)
		console.log('divs', divs)

		const dragDiv = divs.find((div) => div.id === dragId);
		const dropDiv = divs.find((div) => div.id === ev.currentTarget.id);
	
		const dragDivOrder = dragDiv.order;
		const dropDivOrder = dropDiv.order;
	
		const newDivState = divs.map((div) => {
		  if (div.id === dragId) {
			div.order = dropDivOrder;
		  }
		  if (div.id === ev.currentTarget.id) {
			div.order = dragDivOrder;
		  }
		  return div;
		});
	
		console.log('divs', newDivState);*/
	};

	const handleEdit = (id) => {
		set_dados(dados.current.info.media)
	};

	const handleRemove = (id) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				let aux = dados.current.info.media.image.filter(v => v.id !== id)
				set_dados(dados.current.info.media.image = aux)

			}
		})

	};

	const handleChangeContentMediaImage = (e) => {
		const { value, name, dataset } = e.target;
		const { id } = dataset

		dados.current.info.media.image.forEach(el => {
			if(el.id === id)
				el[name] = value
		})
		set_dados(dados.current.infomedia.image)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

        set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {
				set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
				setLoading(false)
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
							
							files_image.forEach(async (el_image) => {
								if(el_image !== null) {
									await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
								}
							})
							set_files_image([])

						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {
			dados.current.info['uniqid'] = uid

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 

							reqGET(`${api_crud_base}/store/brand/product/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									console.log(res.data)
									dados.current.id = res.data[0].id

									files_image.forEach(async (el_image) => {
										if(el_image !== null) {
											await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
										}
									})
									set_files_image([])

									set_is_edit(true)
									set_show_delete_button(true)
								})
								.catch(() => 404)

						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { /*order,*/ lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if(dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if(dados.current.info.language.length  === 0) {
				//dados.current.info.language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.info.language[langid] = {id: langid, code: lang, name: '', description: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)
		
		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSingleCheck = e => {
		const { name } = e.target;

		set_dados(dados.current.info[name] = !dados.current.info['status'])
	}

	const get_value_info_lang = (langid, name) => {
		if(dados.current.info['language'] !== undefined && dados.current.info['language'] !== null) {
			if(dados.current.info['language'][langid] !== undefined && dados.current.info['language'][langid] !== null) {
				return dados.current.info['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const convertBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
        
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
        
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

	const onChangeHandlerFilesImage = async (e) => {
       	const { files, dataset } = e.target;
		const { langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if((v.type.includes('image/')) && (v.size < 10485760)){
				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(e.target.files[0]);
				let files_img_aux = image_base64
				
				if(files_img_aux === undefined)
					files_img_aux = []
				if(files_img_aux[langid] === undefined)
					files_img_aux[langid] = []
				
				files_img_aux[langid] = [{id: '1', langid: langid, name: v.name, link: base64}]
				set_image_base64(files_img_aux)

				if(langid === '1') {
					if(dados.current.info['media'] === undefined)
						dados.current.info['media'] = {image: [], doc: []}

					if(dados.current.info['media']['image'] !== undefined)
						dados.current.info['media']['image'] = []
				}
				else {
					if(dados.current.info['language'][langid]['media'] === undefined)
						dados.current.info['language'][langid]['media'] = {image: [], doc: []}

					if(dados.current.info['language'][langid]['media'] === undefined)
						dados.current.info['language'][langid]['media'] = {image: [], doc: []}

					if(dados.current.info['language'][langid]['media']['image'] !== undefined)
						dados.current.info['language'][langid]['media']['image'] = []
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else{
				alert( language[ lang ].upload_file_error + v.name);
			}
		});	

		let files_aux = files_image
		files_aux[langid] = {files: storedFiles, order: '1', lang: lang, langid: langid}
		set_files_image(files_aux)
    }

	const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
        files.forEach(async (element) => {
			if(element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element, order, type, langid, lang)
				   .then(() => {
						//console.log('success')
				   })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

	const uploadFile = async (file, order, type, langid, lang) => {
        const formData = new FormData()
        formData.append('files', file)
        formData.append('id', dados.current.id)
        formData.append('type', 'brand')
        formData.append('companycode', dados.current.info.companycode)
        formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

        return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
            .then((res) => { 
                var today_file = new Date()

                let x = {
                    id: '',
                    info: {
                        companycode: getTokenInfo().companycode,
                        type: res.data.mimetype,
                        link: res.data.path + '/' + res.data.name,
                        size: res.data.size,
                        date: today_file
                    },
					content: {
						name: file.name,
                        description: '',
						lang: []
					}
                }

				console.log(langid)
				if(langid === '1'){
					if(type === 'image') {
						dados.current.info['media'][type] = [{ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						}]
					}
					if(type === 'doc') {
						dados.current.info['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}
				else {
					if(type === 'image') {
						dados.current.info['language'][langid]['media'][type] = [{ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						}]
					}
					if(type === 'doc') {
						dados.current.info['language'][langid]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

                reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => { 

                    })
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))
                
				return true

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_content_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													''
												}
											</ul>
										</div>
									</div>
									<div id="div-content">

										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="tab-content" id={"tab_entidade_lang"} >
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_content_language_" + k_lang} role="tabpanel">
																	<div className="row mb-3">
																		<div className="col-md-8">
																			<label className={el_lang.id === '1' ? "fs-5 required fw-bold mb-2" : "fs-5 fw-bold mb-2"}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="name" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.name : get_value_info_lang(el_lang.id, 'name')} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required={el_lang.id === '1' ? 'required' : ''} />
																		</div>

																		<div className="col-md-4">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_abreviation} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="abreviation" value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-md-4">
																			<label className="fs-5 fw-bold mb-2">{language[lang].color}</label>
																			<div className="input-group">
																				<div className="me-5">
																					<input type="color" name="bgColor" value={dados.current.info.bgColor !== '' ? dados.current.info.bgColor : '#000000'} className="form-control form-control-color" placeholder={language[lang].color_placeholder} onChange={handle_change_info} />
																				</div>
																				<span className="form-control">{dados.current.info.bgColor}</span>
																			</div>
																		</div>

																		<div className="col-md-6">
																		</div>

																		<div className="col-md-2">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_status}</label>
																			<div className="input-group">
																				<label className="switch">
																					<input
																						id={'item-switch'}
																						name={"status"}
																						className=""
																						type="checkbox"
																						value={dados.current.info.status}
																						onChange={handleSingleCheck}
																						defaultChecked={dados.current.info.status}
																					/>
																					<span className="slider round" htmlFor={'item-switch'}></span>
																				</label>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-12">
																			<div className="div-image">
																				<label className="col-form-label fw-bold fs-6">{language[lang].images}</label>

																				<div className="dropzone-panel mb-2">
																					<div className="div-form-input col-12 custom-file">
																						<label className="dropzone-select btn btn-sm btn-primary me-2 dz-clickable" htmlFor={"input-files-content-" + el_lang.id}>{language[lang].image_choose}</label>
																						<input 
																							id={"input-files-content-" + el_lang.id}
																							type="file" 
																							accept="image/*"
																							data-langid={el_lang.id}
																							data-lang={el_lang.code}
																							data-type={'image'}
																							className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																							onChange={onChangeHandlerFilesImage}
																						/> 
																					</div>
																				</div>

																				<button type="button" className="btn btn-sm btn-primary mb-5 d-none" data-bs-toggle="modal" data-bs-target={"#kt_modal_media_image"}>
																					{language[lang].image_choose}
																				</button>

																				<div className="row">
																					{
																					el_lang.id === '1' && dados.current.info['media'] !== undefined && dados.current.info['media']['image'] !== undefined ?
																						<>
																							{
																							dados.current.info['media']['image'].map((el_media, k_media) => {
																								return (
																									<DraggableDivImage 
																										key={k_media}
																										divNumber={k_media}
																										idImage={el_media.id}
																										linkImage={el_media.link}
																										nameImage={el_media.name}
																										descImage={el_media['description']}
																										language={language}
																										lang={lang}

																										handleDrag={handleDrag}
																										handleDragOver={handleDrop}
																										//handleDrop={handleDrop}
																										handleDrop={(e) => console.log('drop)')}
																										handleRemove={(e) => handleRemove(el_media.id)}
																										handleEdit={(e) => handleEdit(el_media.id)}
																										handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																									/>
																								)
																							}) 
																							}

																							{
																							image_base64 !== undefined && image_base64[el_lang.id] !== undefined ?
																								image_base64[el_lang.id].map((el_media, k_media) => {
																									return (
																										<DraggableDivImage 
																											key={k_media}
																											divNumber={k_media}
																											idImage={el_media.id}
																											linkImage={el_media.link}
																											nameImage={el_media.name}
																											descImage={el_media['description']}
																											language={language}
																											lang={lang}

																											handleDrag={handleDrag}
																											handleDragOver={handleDrop}
																											//handleDrop={handleDrop}
																											handleDrop={(e) => console.log('drop)')}
																											handleRemove={(e) => handleRemove(el_media.id)}
																											handleEdit={(e) => handleEdit(el_media.id)}
																											handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																										/>
																									)
																								}) 
																							:
																								null
																							}
																						</>
																					: 
																						(
																						dados.current.info['language'] !== undefined && dados.current.info['language'].length > 0 && dados.current.info['language'][el_lang.id]['media'] !== undefined && dados.current.info['language'][el_lang.id]['media']['image'] !== undefined ?
																							<>
																								{
																								dados.current.info['language'][el_lang.id]['media']['image'].map((el_media, k_media) => {

																									return (
																										<DraggableDivImage 
																											key={k_media}
																											divNumber={k_media}
																											idImage={el_media.id}
																											linkImage={el_media.link}
																											nameImage={el_media.name}
																											descImage={el_media['description']}
																											language={language}
																											lang={lang}

																											handleDrag={handleDrag}
																											handleDrop={handleDrop}
																											handleRemove={(e) => handleRemove(el_media.id)}
																											handleEdit={(e) => handleEdit(el_media.id)}
																											handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																										/>
																									)
																								})
																								}

																								{
																								image_base64 !== undefined && image_base64[el_lang.id] !== undefined ?
																									image_base64[el_lang.id].map((el_media, k_media) => {
																										return (
																											<DraggableDivImage 
																												key={k_media}
																												divNumber={k_media}
																												idImage={el_media.id}
																												linkImage={el_media.link}
																												nameImage={el_media.name}
																												descImage={el_media['description']}
																												language={language}
																												lang={lang}

																												handleDrag={handleDrag}
																												handleDragOver={handleDrop}
																												//handleDrop={handleDrop}
																												handleDrop={(e) => console.log('drop)')}
																												handleRemove={(e) => handleRemove(el_media.id)}
																												handleEdit={(e) => handleEdit(el_media.id)}
																												handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																											/>
																										)
																									}) 
																								:
																									null
																								}
																							</>
																						: 
																							''
																						) 
																					}
																				</div>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-md-12">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																			<AssecCKEditor
																				name={"text"}
																				content={el_lang.id === '1' ? dados.current.info.description : get_value_info_lang('0', el_lang.id, 'description')}
																				func={(e) => handle_change_content_ckeditor(e, '0', el_lang.id, el_lang.code, 'description')}
																			/>

																			<textarea className="form-control d-none" type="text" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>
																</div>
															)
														})
													:
														<div>
															<div className="row mb-3">
																<div className="col-md-8">
																	<label className="fs-5 required fw-bold mb-2">{language[lang].field_name}</label>
																	<input type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_abreviation}</label>
																	<input type="text" name="abreviation" value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-4">
																	<label className="fs-5 fw-bold mb-2">{language[lang].color}</label>
																	<div className="input-group">
																		<div className="me-5">
																			<input type="color" name="bgColor" value={dados.current.info.bgColor !== '' ? dados.current.info.bgColor : '#000000'} className="form-control form-control-color" placeholder={language[lang].color_placeholder} onChange={handle_change_info} />
																		</div>
																		<span className="form-control">{dados.current.info.bgColor}</span>
																	</div>
																</div>

																<div className="col-md-6">
																</div>

																<div className="col-md-2">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_status}</label>
																	<div className="input-group">
																		<label className="switch">
																			<input
																				id={'item-switch'}
																				name={"status"}
																				className=""
																				type="checkbox"
																				value={dados.current.info.status}
																				onChange={handleSingleCheck}
																				defaultChecked={dados.current.info.status}
																			/>
																			<span className="slider round" htmlFor={'item-switch'}></span>
																		</label>
																	</div>
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-12">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_description}</label>

																	<AssecCKEditor
																		name={"text"}
																		content={dados.current.info.description}
																		func={(e) => handle_change_content_ckeditor(e, '0', '1', 'pt', 'description')}
																	/>

																	<textarea className="form-control d-none" type="text" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																</div>
															</div>
														</div>
													}
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button type="button" onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
